import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const ContentPage = () => {
  const { category, courseName, subjectName } = useParams();
  const [sources, setSources] = useState([]);

  const normalizedCategory = decodeURIComponent(category || "");
  const normalizedCourse = decodeURIComponent(courseName || "");
  const normalizedSubject = decodeURIComponent(subjectName || "");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/course/coursedetails`
        );
        const data = await response.json();
        setSources(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // Filter subjects
  const filteredData = sources.filter(
    (item) =>
      item.category_name === normalizedCategory &&
      item.course_name === normalizedCourse &&
      item.subject_name === normalizedSubject
  );

  // ✅ UNIQUE topics using Set()
  const uniqueTopics = [...new Set(filteredData.map(item => item.topic_title))];

  return (
    <div>
      <h1 style={{ textAlign: "center", color: "#2873b9ff" }}>
        {normalizedSubject}
      </h1>

      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        {uniqueTopics.length > 0 ? (
          uniqueTopics.map((topic, index) => (
            <Link
              key={index}
              to={`/${encodeURIComponent(
                normalizedCategory
              )}/${encodeURIComponent(normalizedCourse)}/${encodeURIComponent(
                normalizedSubject
              )}/${encodeURIComponent(topic)}`}
              style={{ textDecoration: "none" }}
            >
              <div
                style={{
                  border: "1px solid #2873b9ff",
                  padding: "20px",
                  margin: "10px 0",
                  borderRadius: "10px",
                  backgroundColor: "#f9f9ff",
                }}
              >
                <p>
                  <strong>Topic:</strong> {topic}
                </p>
              </div>
            </Link>
          ))
        ) : (
          <p
            style={{
              textAlign: "center",
              color: "gray",
              marginTop: "40px",
              fontSize: "18px",
            }}
          >
            No topics found for this subject.
          </p>
        )}
      </div>
    </div>
  );
};

export default ContentPage;
